export interface UserFormatInput {
  userName?: string;
  sapNumber?: string;
  defaultValue?: string;
}

export const formatUserName = (input: UserFormatInput): string => {
  const { userName, sapNumber, defaultValue } = input;
  if (userName && sapNumber) {
    return `${userName} (${sapNumber})`;
  }

  if (!userName && sapNumber) {
    return sapNumber;
  }

  if (userName && !sapNumber) {
    return userName;
  }

  return defaultValue || '';
};
